export const PROFILE_PICTURE = 'https://i.pinimg.com/736x/93/f5/ce/93f5cee1fc7a96d80a41c73bb6c8d837--body-anatomy-anatomy-study.jpg'
export const USER_COLAPSE_BLOCK_TITLE_CHAR_LIMIT = 18

export const errorObject = {
  'validation_failed.group_name:invalid': 'Некорректное имя группы',
  'validation_failed.group_permissions:not_allowed_for_tenant': 'Группа может иметь процессы которые принадлежат тенанту',
  'validation_failed.group_name:not_unique': 'Группа пользователей с таким же названием уже существует в системе',
}
